<template>
  <div v-if="datas" class="filter-container">
    <div class="columns is-multiline">
      <div class="column is-4">
        <b-field label="De">
          <b-datepicker
            class="input"
            v-model="startDateFormatted"
            :date-formatter="dateFormatter"
            :day-names="dayNames"
            :month-names="monthNames"
            placeholder="Data inicial"
            @input="
              () => {
                INIT_DATE_FILTER(startDateFormatted)
                $emit('date-ready')
              }
            "
          />
        </b-field>
      </div>

      <div class="column is-4">
        <b-field label="até">
          <b-datepicker
            class="input"
            v-model="endDateFormatted"
            :day-names="dayNames"
            :month-names="monthNames"
            placeholder="Data final"
            @input="
              () => {
                END_DATE_FILTER(endDateFormatted)
                $emit('date-ready')
              }
            "
          />
        </b-field>
      </div>
      <div class="column is-4" v-if="endDate || startDate ? true : false">
        <a
          class="clearFilter"
          @click="
            () => {
              clear()
              $emit('date-ready')
            }
          "
        >
          Limpar filtros
        </a>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as MutationTypes from '@/store/modules/mutation-types.js'
import { format } from 'date-fns'

export default {
  name: 'FilterData',

  props: {
    datas: {
      type: Object
    }
  },

  data() {
    return {
      date: new Date(),
      startDate: null,
      endDate: null,
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ],
      dayNames: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
    }
  },

  computed: {
    startDateFormatted: {
      get() {
        return this.datas?.dataInicio
      },
      set(val) {
        this.datas.dataInicio = val
      }
    },
    endDateFormatted: {
      get() {
        return this.datas?.dataTermino
      },
      set(val) {
        this.datas.dataTermino = val
      }
    }
  },
  mounted() {
    this.INIT_DATE_FILTER(null)
    this.END_DATE_FILTER(null)
  },
  methods: {
    ...mapMutations([
      MutationTypes.INIT_DATE_FILTER,
      MutationTypes.END_DATE_FILTER
    ]),
    clear() {
      this.startDate = null
      this.endDate = null
      this.INIT_DATE_FILTER(null)
      this.END_DATE_FILTER(null)
    },

    dateFormatter(date) {
      return format(date, 'dd/MM/yyyy')
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/forms';
@import '~@/assets/stylesheets/buttons';
.dropdown-menu {
  width: fit-content;
}
.dropdown-content {
  background-color: white;
}
.filter-container {
  max-width: 43.75rem;
  max-height: 4.375rem;
  .column {
    padding-right: 0;
  }
  .field {
    display: flex;
    justify-content: flex-start;
    .label {
      line-height: 2;
    }
  }
  .control {
    box-shadow: none;
    border: none;
  }
  .dropdown-trigger {
    .control {
      &::before {
        top: 0.275rem;
      }
      &:after {
        top: 0.4rem;
      }
    }
  }
}
@media (max-width: 64rem) {
  .filter-container {
    max-height: 100%;
    .column {
      padding-left: 0;
      .datepicker > .control {
        width: 100%;
      }
    }
  }
}

.modal .animation-content .modal-card {
  overflow: visible !important;
}

.modal-card-body {
  overflow: visible !important;
}
</style>
<style>
.filter-container .mdi.mdi-chevron-left.mdi-24px:after {
  content: '◄';
  color: var(--light-blue);
  font-style: normal;
}
.filter-container .mdi.mdi-chevron-right.mdi-24px:after {
  content: '►';
  color: var(--light-blue);
  font-style: normal;
}
</style>
